export default __webpack_public_path__ + "static/media/gradient_candle_right_desktop.c027c849.png";